import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=3f29543c&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=3f29543c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f29543c",
  null
  
)

export default component.exports